import React, { useEffect, useState } from 'react';
import Media from 'react-media';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import { useUserState } from 'contexts/auth-context';
import t from 'utils/translateFunc';
import trackingEvent from 'utils/trackingEvent';

import {
  Loader,
  TableDeleteArticles,
  BtnGrey32
} from 'components/common/Elements/Elements';

import { getRequest, putRequest, deleteRequest } from 'utils/requests';

import { parsForTable } from './helpers/helpers';

import classes from './DelGroups.module.scss';

const DelGroups = ({ mixpanel }) => {
  const language = useUserState().user.language;
  const username = useUserState().user.username;

  const [loading, setLoading] = useState(true);
  const [dataGropups, setDataGropups] = useState([]);

  let history = useHistory();

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  const getData = () => {
    getRequest('/api/press-release-groups/?deleted=true')
      .then(res => {
        setDataGropups(parsForTable(res));
        setLoading(false);
      })
      .catch(err => {
        console.log(err);
      });
  };

  const resetablishGroup = id => {
    trackingEvent('resetablish_group', mixpanel, username);
    const REQ_BODY = {
      deleted: false
    };
    putRequest(`/api/press-release-groups/${id}/`, REQ_BODY)
      .then(() => {
        history.push(`/groups`);
      })
      .catch(err => {
        console.log(err);
      });
  };

  const onClear = () => {
    trackingEvent('clear_trash', mixpanel, username);
    deleteRequest(`/api/press-release-groups/clear`)
      .then(() => {
        getData();
      })
      .catch(err => {
        console.log(err);
      });
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <section className={classes.release}>
      <Media
        queries={{
          small: '(max-width: 1279px)',
          large: '(min-width: 1280px)'
        }}
      >
        {matches => (
          <div className={classes.list}>
            <h2 className={classes.title}>
              <p>
                {t('groupsRelease', 'DEL_GROUPS', language)}{' '}
                <span>
                  {dataGropups.length > 0 && `(${dataGropups.length})`}
                </span>
              </p>
              {dataGropups.length > 0 && matches.large && (
                <BtnGrey32
                  className={classes.btnClear}
                  textButton={t('delGroups', 'CLEAR', language)}
                  onClick={onClear}
                />
              )}
            </h2>
            {dataGropups.length === 0 ? (
              <p className={classes.notDeleted}>
                {t('delGroups', 'NOT_DELETED', language)}
              </p>
            ) : (
              <>
                <div className={classes.wrapForMobile}>
                  <TableDeleteArticles
                    articlesData={dataGropups}
                    onClick={resetablishGroup}
                  />
                </div>
                {matches.small && (
                  <BtnGrey32
                    className={classes.btnClear}
                    textButton={t('delGroups', 'CLEAR', language)}
                    onClick={onClear}
                  />
                )}
              </>
            )}
          </div>
        )}
      </Media>
    </section>
  );
};

DelGroups.propTypes = {
  mixpanel: PropTypes.object
};

export default DelGroups;
